import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useHistory } from 'react-router';
import GenericModal from '@components/Modals/GenericModal';
import ModalContent from '@components/Modals/components/ModalContent';
import ModalStatusBanner from '@components/Modals/components/ModalStatusBanner';
import CrossCloseIcon from '@components/UI/CrossCloseIcon';
import { intervalToDuration } from 'date-fns';
import BoxButton from '@components/Buttons/BoxButton';
import useStyles from '../style';
import isMobileBrowser from '@helpers/isMobileBrowser';
const CountDown = ({ errorCode, nextLifted, }) => {
    const { classes } = useStyles();
    const currentDate = new Date();
    const nextLiftedDate = new Date(nextLifted);
    const { days, hours, minutes, seconds } = intervalToDuration({ start: currentDate, end: nextLiftedDate });
    let dayText = ` Day${days && days > 1 ? 's' : ''}`;
    let hourText = ` Hour${hours && hours > 1 ? 's' : ''}`;
    let minuteText = ` Minute${minutes && minutes > 1 ? 's' : ''}`;
    let secondText = ` Second${seconds && seconds > 1 ? 's' : ''}`;
    if (isMobileBrowser()) {
        dayText = 'd';
        hourText = 'h';
        minuteText = 'm';
        secondText = 's';
    }
    let remainingTime = '';
    switch (true) {
        case !!days: {
            remainingTime = `${days}${dayText} ${hours}${hourText}`;
            break;
        }
        case !!hours: {
            remainingTime = `${hours}${hourText} ${minutes}${minuteText}`;
            break;
        }
        case !!minutes: {
            remainingTime = `${minutes}${minuteText} ${seconds}${secondText}`;
            break;
        }
        case !!seconds: {
            remainingTime = `${seconds}${secondText}`;
            break;
        }
    }
    return (_jsxs("div", { className: classes.remainingTime, children: [errorCode === 'DEPOSIT_LIMIT_REACHED' && _jsx("p", { children: "Deposit limit is lifted in:" }), errorCode === 'WITHDRAWAL_COUNT_LIMIT_REACHED' && _jsx("p", { children: "Withdrawal requests are available in:" }), _jsx("h2", { children: remainingTime })] }));
};
const DepositWarningDetail = ({ transactionWarningModalData, handleClose }) => {
    const { classes } = useStyles();
    const history = useHistory();
    const handleNavigateToAccountSetting = () => {
        history.push('/account/details?verify=true');
        handleClose();
    };
    if (transactionWarningModalData.nextLifted) {
        return (_jsxs(_Fragment, { children: [_jsx("p", { className: classes.currencyText, children: "Your account has reached the maximum deposit limit, please try again in 24 hours" }), _jsx("p", { className: classes.currencyText, children: "We take your account security and platform integrity very seriously. Thank you for your understanding." }), _jsx(CountDown, { nextLifted: transactionWarningModalData.nextLifted, errorCode: transactionWarningModalData.errorCode }), _jsx(BoxButton, { className: classes.fullWidth, onClick: handleClose, size: "lg", variant: "primary", children: "Close" })] }));
    }
    else {
        return (_jsxs(_Fragment, { children: [_jsx("p", { className: classes.currencyText, children: "This deposit has been prevented as you have reached the maximum allowed deposit limit for unverified accounts." }), _jsx("p", { className: classes.currencyText, children: "To deposit more money, you will need to verify your identity." }), _jsx("p", { className: classes.currencyText, children: "Note: We have not processed this transaction." }), _jsx(BoxButton, { className: classes.fullWidth, onClick: handleNavigateToAccountSetting, size: "lg", variant: "primary", children: "Verify Now" })] }));
    }
};
const WithdrawalWarningDetail = ({ transactionWarningModalData, handleClose }) => {
    const { classes } = useStyles();
    return (_jsxs(_Fragment, { children: [_jsx("p", { className: classes.currencyText, children: "To remain legally compliant and prevent fraud, you cannot withdraw after making a recent withdrawal. We automatically place a cooldown on your account." }), _jsx("p", { className: classes.currencyText, children: "We take your account security and platform integrity very seriously. Thank you for your understanding." }), transactionWarningModalData.nextLifted && (_jsx(CountDown, { nextLifted: transactionWarningModalData.nextLifted, errorCode: transactionWarningModalData.errorCode })), _jsx(BoxButton, { className: classes.fullWidth, onClick: handleClose, size: "lg", variant: "primary", children: "Close" })] }));
};
/**
 * Modal for showing warning transaction limitation
 */
const TransactionWarningModal = ({ onCallback, transactionWarningModalData, setTransactionWarningModalData, }) => {
    const { classes } = useStyles();
    const handleClose = () => {
        setTransactionWarningModalData({ isShow: false, nextLifted: null, errorCode: null });
        onCallback();
    };
    return (_jsxs(GenericModal, { show: true, size: "small", children: [_jsx(CrossCloseIcon, { action: handleClose, className: classes.closeBtn }), _jsxs(ModalContent, { align: "center", children: [_jsx(ModalStatusBanner, { status: "pending" }), _jsx("h2", { children: "Security Notice" }), transactionWarningModalData.errorCode === 'DEPOSIT_LIMIT_REACHED' && (_jsx(DepositWarningDetail, { transactionWarningModalData: transactionWarningModalData, handleClose: handleClose })), transactionWarningModalData.errorCode === 'WITHDRAWAL_COUNT_LIMIT_REACHED' && (_jsx(WithdrawalWarningDetail, { transactionWarningModalData: transactionWarningModalData, handleClose: handleClose }))] })] }));
};
export default TransactionWarningModal;
